import { css } from 'styled-components';
import {
  BreakpointQueryName,
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/bricks';
import { borderRadiusRem } from '../../constant';

export const base: ThemedFunctor = ({
  theme,
  $active,
}) => css`
${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.MEDIUM, SpacingName.SMALL])}
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: ${borderRadiusRem}rem;
  background-color: ${theme.palettes.neutrals.lightest};
  display: flex;
  flex-direction: column;
  gap: ${theme.spaceUnits.mobile.SMALL};
  user-select: none;

  ${$active && `
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  `}

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    gap: ${theme.spaceUnits.desktop.SMALL};
  }
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaceUnits.mobile.SMALLEST};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    gap: ${theme.spaceUnits.desktop.SMALLEST};
  }
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ul {
    padding-left: 1rem;
  }

  li {
    ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
    list-style: square;
  }
`;
